import React from 'react';

function PreviewModal({
  videoUrl,
  onDownload,
  onReset,
}) {

  if (!videoUrl) return null;

  return (
    <div style={styles.overlay}>

      <div style={styles.modal}>

        {/* Header */}
        <div style={styles.header}>
          <div>
            <h2 style={styles.title}>
              Enregistrement terminé
            </h2>

            <p style={styles.subtitle}>
              Vous pouvez visionner ou télécharger la vidéo.
            </p>
          </div>

          <button
            style={styles.closeButton}
            onClick={onReset}
          >
            ✕
          </button>
        </div>

        {/* Preview */}
        <video
          src={videoUrl}
          controls
          style={styles.video}
        />

        {/* Actions */}
        <div style={styles.actions}>

          <button
            style={styles.secondaryButton}
            onClick={onReset}
          >
            Supprimer
          </button>

          <button
            style={styles.primaryButton}
            onClick={() => {
              onDownload();
              onReset();
            }}
          >
            Arrêter et télécharger
          </button>

        </div>

      </div>

    </div>
  );
}

const styles = {

  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.45)',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    zIndex: 99999,
  },

  modal: {
    width: '550px',
    maxWidth: '92%',
    background: '#fff',
    borderRadius: '18px',
    padding: '24px',
    boxShadow:
      '0 10px 40px rgba(0,0,0,0.18)',

    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },

  title: {
    margin: 0,
    fontSize: '22px',
    fontWeight: 600,
    color: '#1F1F1F',
  },

  subtitle: {
    marginTop: '6px',
    fontSize: '14px',
    color: '#666',
  },

  closeButton: {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',

    fontSize: '20px',
    color: '#777',
  },

  video: {
    width: '100%',
    borderRadius: '12px',
    background: '#000',
  },

  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
  },

  secondaryButton: {
    border: '1px solid #DDD',
    background: '#FFF',

    padding: '10px 16px',

    borderRadius: '10px',

    cursor: 'pointer',

    fontSize: '14px',
  },

  primaryButton: {
    border: 'none',
    background: '#D93025',
    color: '#FFF',

    padding: '10px 18px',

    borderRadius: '10px',

    cursor: 'pointer',

    fontSize: '14px',
    fontWeight: 500,
  },
};

export default PreviewModal;